import { render, staticRenderFns } from "./FormElementTable.vue?vue&type=template&id=852d5d24&scoped=true"
import script from "./FormElementTable.vue?vue&type=script&lang=js"
export * from "./FormElementTable.vue?vue&type=script&lang=js"
import style0 from "./FormElementTable.vue?vue&type=style&index=0&id=852d5d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852d5d24",
  null
  
)

export default component.exports